console.log('✅ router.js loaded successfully!');

import { APP_CONFIG } from './config.js';
import { safeDecodeURI } from './utils-urls.js';

import { appState, getValidLanguageFromAppState, setValidLanguageToAppState } from './state.js';
import { getCurrentBrowserFirstValidLanguage } from './utils-browser.js';

import { buildContentForPageByPageBuilderContentManager } from './build-manager-pages.js';
import { setFullPageIntoView } from './router-content-replacer.js';
import { loadTextTranslations } from './translator.js';
import {
  ensureRoutesLoaded,
  routeMappings,
  GetPageTranslateKeyPageURL,
} from './router-routes-manager.js';

//// Lazy-loaded modules (to be imported dynamically)
//let buildContentForPageByPageBuilderContentManager;
//let setFullPageIntoView;
//let loadTextTranslations;
//let ensureRoutesLoaded;
//let routeMappings;
//let GetPageTranslateKeyPageURL;

const validLanguageCodes = APP_CONFIG.VALID_LANGUAGE_CODES;
//const baseURL = APP_CONFIG.BASE_URL;

/** * Resolve language and route this method should basically on be a check for the routes.json file */
async function resolveRoute(path) {
  console.log('🔍 resolveRoute Resolving path...', path);

  await ensureRoutesLoaded(); // Ensure routes.json is loaded

  if (!routeMappings) {
    console.error('❌ Critical error: routeMappings is still undefined. Falling back to 404.');
    return { language: 'en', page: '404', params: [], valuesInUrl: '' }; // Safe fallback
  }

  let [cleanPath, valuesInUrl = ''] = path.split('?'); // Remove trailing slashes

  let segments = cleanPath.split('/').filter(Boolean);

  let language = segments[0];
  let pageSegment = segments[1];
  let params = segments.slice(2); // this is a string

  console.log(
    `🔍 Resolving route first level... lang: ${language}, page: ${pageSegment}, params: ${params}, valuesInUrl: ${valuesInUrl}`
  );

  if (language) {
    //Cleans Trailing Slash in Language Code
    language = language.replace(/\/$/, '');
  }

  //Checks if Language Code is Valid
  if (!validLanguageCodes.includes(language)) {
    let userLang = getValidLanguageFromAppState() || getCurrentBrowserFirstValidLanguage() || 'en';

    if (!validLanguageCodes.includes(userLang)) userLang = 'en';

    //if the cookie is not set to the language in the url, set it to the language in the url
    if (!getValidLanguageFromAppState()) {
      setValidLanguage(userLang);
    }

    // language = userLang;
    // pageSegment = segments[0];
    // params = segments.slice(1);

    //rebuild the path with the new language
    cleanPath = `/${userLang}/${cleanPath.replace(/^\//, '')}`;

    segments = path.split('/').filter(Boolean);
    language = segments[0];
    pageSegment = segments[1];
    params = segments.slice(2);

    console.log(
      `🔍 Resolving route second level... lang: ${language}, page: ${pageSegment}, params: ${params}, valuesInUrl: ${valuesInUrl}`
    );
  }

  // count the slashes in the path, 7 slashes means listing page, 5 slashes means product page, 4 slashes means category page, 3 slashes means subcategory page, 2 slashes means categories page, 1 slash means home page
  // alert(`resolveRoute 3: lang: ${language}, page: ${pageSegment}, params: ${params}`);

  console.log(
    `🔍 Resolving route fourth level... lang: ${language}, page: ${pageSegment}, params: ${params}, valuesInUrl: ${valuesInUrl}`
  );

  //console.log(`🔍 Type of params: ${typeof params}`);

  const slashCount = cleanPath.split('/').length - 1;
    console.log(`🔍 Resolving route fourth level slash count: ${slashCount}`);

  if (slashCount === 10) {
    pageSegment = 'listing';
    params = segments[1] + ',' + params;

    console.log(
      `🔍 Resolving route fourth level listing page... lang: ${language}, page: ${pageSegment}, params: ${params}, valuesInUrl: ${valuesInUrl}`
    );
  } else if (slashCount === 7) {
    pageSegment = 'product';
    params = segments[1] + ',' + params;
    console.log(
      `🔍 Resolving route fourth level product page... lang: ${language}, page: ${pageSegment}, params: ${params}, valuesInUrl: ${valuesInUrl}`
    );
  } else if (slashCount === 5) {
    pageSegment = 'subcategory';
    params = segments[1] + ',' + params;
    console.log(
      `🔍 Resolving route fourth level subcategory page... lang: ${language}, page: ${pageSegment}, params: ${params}, valuesInUrl: ${valuesInUrl}`
    );
  } else if (slashCount === 3) {
    pageSegment = 'category';
    params = segments[1] + ',' + params;
    console.log(
      `🔍 Resolving route fourth level category page... lang: ${language}, page: ${pageSegment}, params: ${params}, valuesInUrl: ${valuesInUrl}`
    );
  }
  else if (slashCount === 6) {

      let matchedBlogPage = await GetPageTranslateKeyPageURL(pageSegment);

      if (matchedBlogPage === 'keyBlog') {
      pageSegment = 'blog-article';
      params = segments[1] + ',' + params;
      console.log(
        `🔍 Resolving route fourth level blog-article page... lang: ${language}, page: ${pageSegment}, params: ${params}, valuesInUrl: ${valuesInUrl}`
      );
    }
  } else if (slashCount === 4) {

      let matchedBlogPage = await GetPageTranslateKeyPageURL(pageSegment);

      if (matchedBlogPage === 'keyBlog') {
      pageSegment = 'blog-category';
      params = segments[1] + ',' + params;
      console.log(
        `🔍 Resolving route fourth level blog-category page... lang: ${language}, page: ${pageSegment}, params: ${params}, valuesInUrl: ${valuesInUrl}`
      );
    }
  } else if (slashCount === 1) {
    pageSegment = 'home';

    console.log(
      `🔍 Resolving route fourth level  home page... lang: ${language}, page: ${pageSegment}, params: ${params}, valuesInUrl: ${valuesInUrl}`
    );
  } else if (slashCount === 0) {
    pageSegment = 'home';
    params = [];
    console.log(
      `🔍 Resolving route fourth level home page... lang: ${language}, page: ${pageSegment}, params: ${params}, valuesInUrl: ${valuesInUrl}`
    );
  } else if (slashCount > 7) {
    console.warn(
      `⚠️ Resolving route fourth level Too many slashes in URL: ${cleanPath}. Defaulting to home page.`
    );
    pageSegment = 'home';
    params = [];
    console.log(
      `🔍 Resolving route fourth level default to home page... lang: ${language}, page: ${pageSegment}, params: ${params}, valuesInUrl: ${valuesInUrl}`
    );
  } else if (slashCount < 1) {
    console.warn(
      `⚠️ Resolving route fourth level No slashes in URL: ${cleanPath}. Defaulting to home page.`
    );
    pageSegment = 'home';
    params = [];
    console.log(
      `🔍 Resolving route fourth level Resolving route home page... lang: ${language}, page: ${pageSegment}, params: ${params}, valuesInUrl: ${valuesInUrl}`
    );
  }

  if (segments.length === 0 || pageSegment === 'index.html' || !pageSegment) {
    pageSegment = 'home';
    params = [];
  }

  // alert(`resolveRoute 5: lang: ${language}, page: ${pageSegment}, params: ${params}`);

  console.log(
    `🔍 Resolving route at fifth level ... lang: ${language}, page: ${pageSegment}, params: ${params}, valuesInUrl: ${valuesInUrl}`
  );

  let matchedPage = await GetPageTranslateKeyPageURL(pageSegment);

  if (matchedPage) {
    //   alert(`resolveRoute 6: lang: ${language}, page: ${matchedPage}, params: ${params}`);
    console.log(
      `✅ Resolved route: lang: ${language}, matched page: ${matchedPage}, params: ${params}, valuesInUrl: ${valuesInUrl}`
    );

    return { language, page: matchedPage, params, valuesInUrl };
  } else {
    //  alert(`resolveRoute 6B (no match for roue): lang: ${language}, page: 404, params: ${params}`);

    console.warn(
      `⚠️ 404 No route resolved or found for: lang: ${language}, page: ${pageSegment}, params: ${params}, valuesInUrl: ${valuesInUrl}, matched page: ${matchedPage}`
    );

    return { language, page: '404', params, valuesInUrl };
  }
}

export async function loadPageFromURL() {
  // FYI any time this runs it will be from live view

  console.log('🔄 Loading page from URL...');

  await ensureRoutesLoaded(); // Ensure routes.json is loaded

  console.log('🔄 Loading page from URL Routes loaded:');

  if (!routeMappings) {
    console.error('❌ Critical error: routeMappings is still undefined.');
    document.getElementById('content').innerHTML = '<p>Error: Routes could not be loaded.</p>';
    return;
  }

  let fullURL = safeDecodeURI(window.location.href);

  let path = fullURL.replace(appState.BASE_URL, '');

  fullURL = fullURL.replace(/\/$/, '');
  //clean trailing slashes
  path = path.replace(/\/$/, '');

  if (path.replace(/\/$/, '') === appState.BASE_URL.replace(/\/$/, '')) {
    path = '';
  }

  console.log('🔄 Loading page from Base URL:', appState.BASE_URL);
  console.log('🔄 Loading page from Full URL:', fullURL);
  console.log('🔄 Loading page from URL Path:', path);

  if (fullURL === path) {
    path = path.replace(/\/$/, '');
  }

  let { language, page, params, valuesInUrl } = await resolveRoute(path);

  console.log(
    `🔄 loadPageFromURL route resolved language: ${language}, page: ${page}, params: ${params}, valuesInUrl: ${valuesInUrl}`
  );

  // console.log("🔄 loadPageFromURL sending page to be built by :");

  //  console.log(`🔄 1 loadPageFromURL sending page to be built by : appState.SiteLanguageCookie, ${appState.SiteLanguageCookie} , language: ${language}`);

  //check if the language  is valid if not check if the appState langauge is valid and use it instead
  if (!validLanguageCodes.includes(language)) {
    console.warn(
      `⚠️ Invalid language code in URL: ${language}. Defaulting to appState.SiteLanguageCookie: ${appState.SiteLanguageCookie}`
    );
    language = appState.SiteLanguageCookie;
  }

  if (appState.SiteLanguageCookie !== language) {
    console.log(
      '🔄 loadPageFromURL language not matching, updating app state and loading translations...'
    );

    setValidLanguageToAppState(language);

    // the new app state has to be set first
    await applyLanguageSettings(language);

    console.log('✅ Language updated:', language);
  }
  //appState.SiteLanguageCookie

  // console.log(`🔄 2 loadPageFromURL sending page to be built by buildContentForPageByPageBuilderContentManager: appState.SiteLanguageCookie, ${appState.SiteLanguageCookie}`);

  // let newFullPageContentIncludingMasterPage = await buildContentForPageByPageBuilderContentManager(page, params, valuesInUrl);

  const {
    masterPageName,
    masterPageHtml,
    pageContentHtml,
    pageHeaderTags,
  } = await buildContentForPageByPageBuilderContentManager(page, params, valuesInUrl);

  // console.log("🔄 loadPageFromURL returned built content:", newFullPageContentIncludingMasterPage);

  // FYI any time this parent method  runs it will be from live view
  // setFullPageIntoView(newFullPageContentIncludingMasterPage);

    console.log(`🌐external trggering start - SetFullPageIntoView - ${page} `);

  setFullPageIntoView(masterPageName, masterPageHtml, pageContentHtml, pageHeaderTags);
    console.log(`🌐external trggering end - SetFullPageIntoView - ${page} `);
}

// To cancel the request (call this if needed)
function cancelSSRRequest() {
  controller.abort();
  console.log('🚫 SSR request cancelled');
}

export function extractValidLanguageCodeFromURL(url) {
  let path = url.replace(appState.BASE_URL, '');

  let segments = path.split('/').filter(Boolean);
  let language = segments[0];

  console.log(`🔍 Extracting language code from url: ${url}`);

  console.log(`🔍 Extracting language code from URL language found: ${language}`);

  if (!validLanguageCodes.includes(language)) {
    return 'en';
  }
  return language;
}

export function urlHasvalidLanguageCode(url) {
  let path = url.replace(appState.BASE_URL, '');

  let segments = path.split('/').filter(Boolean);
  let language = segments[0];

  console.log(`🔍 Extracting language code from url: ${url}`);

  console.log(`🔍 Extracting language code from URL language found: ${language}`);

  if (!validLanguageCodes.includes(language)) {
    return false;
  }
  return true;
}

/**
 * Apply language settings (direction & HTML attributes)
 */
export async function applyLanguageSettings(language) {
  await loadTextTranslations(language);

  document.documentElement.lang = language;
  document.documentElement.dir = language === 'ar' ? 'rtl' : 'ltr';
}

export async function updateLanguageInURL(newLang) {
  //FYI updateLanguageInURL updates the url and then reloads pages and the new langauge is picked up and saved on the page load aka loadPageFromURL

  // alert(`updateLanguageInURL 1: newLang: ${newLang}`);
  console.log('🔄 Updating language in URL to:', newLang);

  let fullURL = safeDecodeURI(window.location.href);
  let path = fullURL.replace(appState.BASE_URL, '');
  let newURL = '';

  if (urlHasvalidLanguageCode(fullURL)) {
    console.log('🔄 Updating language in URL - url has valid langauge');

    // let currentLangaugeInUrl = await extractValidLanguageCodeFromURL(fullURL);
    let currentPath = path.replace(/^\/[a-z]{2}/, '');

    //remove trailing slashes
    currentPath = currentPath.replace(/\/$/, '');

    newURL = `/${newLang}${currentPath}`;
  } else {
    newURL = `/${newLang}`;
  }

  console.log(`🔄 Updating language in URL - newLang : ${newLang} : newURL : ${newURL}`);

  window.history.pushState({}, '', newURL);

  console.log(`🌐 test only language chnage SetFullPageIntoView - trggering`);

  await loadPageFromURL();

  console.log(`🌐 test only language chnage SetFullPageIntoView - trggering`);
}
